<div id="toggle-menu" [ngClass]="{menu: !lightDots, lightDots: lightDots}" [matMenuTriggerFor]="taskOptions">
    <icon matIcon="more_vert"></icon>
</div>
<mat-menu #taskOptions="matMenu" class="condensed">
    <ng-container *ngIf="showDetailOptions">
        <div class="subtitle">VIEW</div>
        <button mat-menu-item [disabled]="!condensedView" (click)="toggleView()" [ngClass]="{active:!condensedView}">Detailed</button>
        <button mat-menu-item [disabled]="condensedView" (click)="toggleView()" [ngClass]="{active:condensedView}">Condensed</button>
        <hr *ngIf="showSortOptions || showMarkAllRead || showHideTasks || showExport" />
    </ng-container>
    <ng-container *ngIf="showSortOptions">
        <div class="subtitle">SORT</div>
        <button mat-menu-item [disabled]="!sortByDate" (click)="toggleSort()" [ngClass]="{active:!sortByDate}">Manual</button>
        <button mat-menu-item [disabled]="sortByDate" (click)="toggleSort()" [ngClass]="{active: !!sortByDate}">Date</button>
        <hr *ngIf="showMarkAllRead || showHideTasks || showExport" />
    </ng-container>
    <button *ngIf="showMarkAllRead" mat-menu-item (click)="taskService.markAllFilteredAsSeen(filterPage)" [disabled]="!unseenTasksCount">Mark all as read</button>
    <button *ngIf="showHideTasks" mat-menu-item (click)="toggleCompletedTasks()">
        {{!hideCompleted ? 'Hide':'Show'}} completed tasks</button>
    <button *ngIf="showExport" mat-menu-item (click)="onExport.emit()">Export</button>
    <button *ngIf="showImport" mat-menu-item (click)="onImport.emit()">Import</button>
</mat-menu>
